import { withProps } from '../components/utils';
import { loadPageWebpack } from './legacy-bootstrap-utils';

const getPerformanceDeps = () => {
  const legacydeps = import(/* webpackMode: "eager" */'./performance-deps');

  return legacydeps;
};
const importPage = () => import(/* webpackMode: "eager" */'@bingads-webui-campaign-react/performance-page');

const importFeature = () => Promise.all([
  importPage(),
  getPerformanceDeps(),
]).then(([thePageModule, performanceDeps]) => withProps(thePageModule.StyledPerformance, performanceDeps));

const Feature = loadPageWebpack({
  importFeature,
  importL10n: () => import(/* webpackChunkName: "performance-page.dynamic.l10n" */'./performance-page.l10n'),
  hasLegacyI18n: true,
});

export default Feature;
